export default "__VITE_ASSET__BnRczXZH__"